/**
 * A "reasonable" default implementation for rendering a label for a tree item.
 *
 * @private
 */
export default function defaultGetItemLabel(item, labelKey) {
    var result = item[labelKey];
    if (typeof result === "undefined") {
        result = item.children;
    }
    if (typeof result === "undefined") {
        result = null;
    }
    return result;
}
//# sourceMappingURL=defaultGetItemLabel.js.map